// extracted by mini-css-extract-plugin
module.exports = {"buttonSelect":"button_select_buttonSelect__3o4xo","or":"button_select_or__1xlwf","wrapper":"button_select_wrapper__2G9Z0","line":"button_select_line__2aeDi"};